module.exports = __webpack_public_path__ + "0bce9b1942ff1aaf6a662942f1e21783.png";